import { assign } from 'lodash';

export default (auth, retry) => (request) => {
  assign(request.options.headers, auth.getRequestHeaders());

  return {
    error({ status }) {
      if (status !== 401) {
        return false;
      }

      if (!request.options.retry) {
        return auth.renew().then(() => retry(request.path, {
          ...request.options,
          retry: true,
        }));
      }

      return false;
    },
  };
};



// WEBPACK FOOTER //
// ./src/Api/middleware/auth.js